import React from "react";
import { motion } from "framer-motion";

export default function VideoSection() {
  return (
    <section
      data-testid="video-section"
      className="relative w-full py-28 sm:py-36 px-6 bg-[#0F0F0F] border-t border-[#1A1A1A]"
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.0 }}
          className="max-w-3xl"
        >
          <p className="text-xs tracking-[0.3em] uppercase text-[#C4451C] mb-5">
            the playground problem
          </p>
          <h2 className="font-marker text-[#E8E5DE] text-4xl sm:text-5xl md:text-6xl leading-[1.05]">
            An egg can survive a fall onto rubber mulch.
            <br />
            <span className="text-[#C4451C]">It cannot survive wood.</span>
          </h2>
          <p className="text-base text-[#A3A3A3] mt-6 max-w-2xl leading-relaxed">
            Watch what happens when we drop an egg from six feet onto each surface.
            Rubber mulch is the only mulch certified to ASTM F-1292 impact attenuation
            standards and IPEMA-rated for falls up to 16 feet. Wood mulch is not.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.0, delay: 0.15 }}
        >
          {/* TODO: Replace placeholder with <video> element once egg-drop.mp4 is added to /public/videos/ */}
          <div
            data-testid="video-placeholder"
            className="w-full mt-12 sm:mt-16 aspect-video bg-[#141414] border border-[#C4451C] flex flex-col items-center justify-center text-center px-6"
          >
            <span className="text-xs tracking-[0.3em] uppercase text-[#737373]">
              video coming soon
            </span>
            <span className="font-marker text-[#E8E5DE] text-2xl sm:text-3xl mt-3">
              egg drop test
            </span>
          </div>

          <p className="text-sm italic text-[#A3A3A3] text-center mt-6">
            Same drop height. Same egg. Different ground cover.
          </p>
        </motion.div>

        <p className="text-[11px] text-[#525252] mt-10 tracking-wider leading-relaxed max-w-3xl">
          Playground safety standards:{" "}
          <a
            href="https://www.astm.org/f1292-22.html"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-[#C4451C]"
          >
            <em>ASTM F-1292 (Standard Specification for Impact Attenuating Surfacing Materials)</em>
          </a>
          ,{" "}
          <a
            href="https://www.astm.org/f1951-21.html"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-[#C4451C]"
          >
            <em>ASTM F-1951 (Standard Specification for Determination of Accessibility of Surface Systems)</em>
          </a>
          , and{" "}
          <a
            href="https://www.ipema.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-[#C4451C]"
          >
            <em>IPEMA certification</em>
          </a>{" "}
          for 16-foot fall protection at 6-inch depth. Wood mulch is not certified to any of
          these standards.
        </p>
      </div>
    </section>
  );
}
